import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core'
import { Breadcrumb } from '@mmx/shared'

import { TitleService } from './title.service'

@Component({
  selector: 'mmx-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  standalone: false,
})
export class PageTitleComponent implements OnInit, OnChanges, OnDestroy {
  @Input() get title(): string {
    return this._title
  }
  set title(value: string) {
    this._title = value
    this.elementRef.nativeElement.title = ''
  }

  @Input() help?: string
  @Input() helpPageId?: string
  @Input() description?: string
  @Input() breadcrumbs?: (Breadcrumb | undefined)[]
  @Input() loading = false

  private _title: string

  constructor(
    private elementRef: ElementRef,
    private titleService: TitleService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.title || 'Loading…')

    if (typeof this.helpPageId === 'string' && !this.help) {
      this.help =
        `https://help.patientpal.com/en/articles/${this.helpPageId}-` +
        encodeURIComponent(this.title)
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.title) {
      this.titleService.setTitle(this.title)
    }
  }

  ngOnDestroy() {
    this.titleService.setTitle('')
  }
}
